// extracted by mini-css-extract-plugin
export default {"cls1":"SimplePaperPodcast-cls1___7ac9d0ebac6e6a906db","cls2":"SimplePaperPodcast-cls2___ea44d97375af1074cba SimplePaperPodcast-cls1___7ac9d0ebac6e6a906db"};